/**
 * Created by Mark on 01/12/2016.
 */


import React from "react";


export default class TableSearchComponent extends React.Component {

    constructor(props){
        super();

        this.props = props;
        this.state = {
            css : props.css  || "search form-group",
            icon : props.icon || "zmdi icon",
            iconName : props.iconName || "glyphicon-search",
            inputClass : props.inputClass || "search-field form-control",
            typingTimer: null,
            onSearch: props.onSearch || this.onFinishedTyping.bind(this)
        }

    }

    handelKeyDown(){
        clearTimeout(this.state.typingTimer);
    }

    handelKeyUp(){
        clearTimeout(this.state.typingTimer);

        this.setState({
            typingTimer:setTimeout(function(){ this.state.onSearch(this.search.value) }.bind(this), 500)
        });
    }

    onFinishedTyping(){

    }


    render(){
        return (
            <div className="search form-group">
                <div className={this.props.className ? this.props.className + " input-group" : "input-group"}>
                    <span className="input-group-addon zmdi icon input-group-addon glyphicon-search"></span>
                    <div className="fg-line">
                        <input type="text"   ref={(input) => this.search = input}   onKeyUp={this.handelKeyUp.bind(this)} onKeyDown={this.handelKeyDown.bind(this)} className="search-field form-control" placeholder=""/>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/tables/table.search.component.js